type MechanicsToolbarProps = Record<string, never>;

export function MechanicsToolbar(_props: MechanicsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຄິວລົງທະບຽນຊ່າງແປງ</h2>
          <p className="text-muted-foreground">
            ລາຍການຊ່າງທີ່ລົງທະບຽນ ກວດສອບ ແລະ ຢືນຢັນຕົວຕົນ
          </p>
        </div>
      </div>
    </div>
  );
}
